import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/app/ProtectedRoute';
import { lazy } from 'react';

const SelectEstablishmentPage = lazy(
  () => import('@/pages/Admin/SelectEstablishmentPage')
);

export const adminRoutes: RouteObject[] = [
  {
    path: 'admin/select-establishment',
    element: (
      <ProtectedRoute roles={['admin']}>
        <SelectEstablishmentPage />
      </ProtectedRoute>
    ),
  },
];
